<script>
  export let product;
  export let max = 7;

  const uniqueVariants = product.variants.sort((a, b) => Number(b.available) - Number(a.available))
    .filter((variant, index, array) => {
      return array.indexOf(array.find(v => v.option1 === variant.option1)) === index;
    });

  // If we're going to show a '+ 1 more' button we might as well
  // just show the last variant button.
  if (uniqueVariants.length === (Number(max) + 1)) {
    max++;
  }

  const variantsToList = uniqueVariants.slice(0, max);
</script>

{#each variantsToList as variant}
  <a
    href="{`${product.url}?variant=${variant.id}`}"
    class="
      btn btn-transparent-black
      {variant.available === false ? 'btn-crossed-off opacity-20' : ''}
      py-0.5 px-1
      hover:bg-black hover:text-white
      b6 flex items-center
    "
  >
    <span>{variant.option1}</span>
  </a>
{/each}

{#if uniqueVariants.length > max}
  <a
    href="{product.url}"
    class="btn btn-transparent-black py-0.5 px-1 hover:bg-black hover:text-white b6 flex items-center"
  >
    <span>
      + {uniqueVariants.length - max} more
    </span>
  </a>
{/if}
